// page.js

import gsap from "gsap";
export function enterPage(pages, index) {
  // 各页面独立动画配置
  switch (index) {
    case 0:
      // Page1.vue
      gsap.fromTo(pages[index].querySelector('.logo'), {
        y: 50,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.zhubiao1'), {
        y: 50,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut"
      });
      // .zhubiao2 is commented out in Vue component, so removing animation
      gsap.fromTo(pages[index].querySelector('.xiaozi'), {
        y: 0,
        opacity: 0,
        scaleX: 0
      }, {
        y: 0,
        opacity: 1,
        scaleX: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.logoA'), {
        y: 50,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.7
      });
      break;
    case 1:
      // Page2.vue
      gsap.fromTo(pages[index].querySelector('.one'), {
        scale: 0,
        // 整体缩小
        opacity: 0,
        transformOrigin: "center center"
      }, {
        scale: 1,
        // 放大到正常大小
        opacity: 1,
        duration: 1.6,
        ease: "power2.inOut"
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.Product'), {
        x: 100,
        // 从右到左
        opacity: 0
      }, {
        x: 0,
        // 到正常位置
        opacity: 1,
        duration: 1.8,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.Productview'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.MANSION'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });

      // 针对 '.wenzi2' 内的每个元素添加动画
      gsap.fromTo(pages[index].querySelector('.two'), {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center"
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.6,
        ease: "power2.inOut"
      });
      gsap.fromTo(pages[index].querySelector('.Space'), {
        x: 100,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1.8,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.MANSION2'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.SpaceScript'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang2'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.9
      });
      gsap.fromTo(pages[index].querySelector('.three'), {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center"
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.6,
        ease: "power2.inOut"
      });
      gsap.fromTo(pages[index].querySelector('.Scene'), {
        x: 100,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1.8,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.SceneDisplay'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.MANSION3'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang3'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.9
      });
      gsap.fromTo(pages[index].querySelector('.chanpin'), {
        x: 200,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.inOut"
      });
      gsap.fromTo(pages[index].querySelector('.konngjian'), {
        x: 200,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 0.9,
        ease: "power2.inOut"
      });
      gsap.fromTo(pages[index].querySelector('.changjing'), {
        x: 200,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut"
      });
      break;
    case 2:
      // Page3.vue
      gsap.fromTo(pages[index].querySelector('.产品观'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.SpaceConcept'), {
        x: 100,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.8
      });
      gsap.fromTo(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.0
      });
      gsap.fromTo(pages[index].querySelector('.word3'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.2
      });
      gsap.fromTo(pages[index].querySelector('.word4'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.4
      });
      gsap.fromTo(pages[index].querySelector('.图片'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.5,
        ease: "power2.inOut",
        delay: 0.5
      });
      break;
    case 3:
      // Page3-1.vue
      gsap.fromTo(pages[index].querySelector('.产品观'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.DecorationConcept'), {
        x: 100,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.8
      });
      gsap.fromTo(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.0
      });
      gsap.fromTo(pages[index].querySelector('.word3'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.2
      });
      gsap.fromTo(pages[index].querySelector('.word4'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.4
      });
      gsap.fromTo(pages[index].querySelector('.图片'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.5,
        ease: "power2.inOut",
        delay: 0.5
      });
      break;
    case 4:
      // Page4.vue
      gsap.fromTo(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.LifeIllustrated'), {
        x: 100,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.3,
        ease: "power2.inOut",
        delay: 0.8
      });
      gsap.fromTo(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.0
      });
      gsap.fromTo(pages[index].querySelector('.word4'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.2
      });
      gsap.fromTo(pages[index].querySelector('.word3'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.4
      });
      gsap.fromTo(pages[index].querySelector('.shijingtu'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.5,
        ease: "power2.inOut",
        delay: 0.5
      });
      break;
    case 5:
      // Page4-2.vue
      gsap.fromTo(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.tu1'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.闲适'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.8
      });
      gsap.fromTo(pages[index].querySelector('.tu2'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 1.0
      });
      gsap.fromTo(pages[index].querySelector('.垂钓'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.2
      });
      gsap.fromTo(pages[index].querySelector('.tu3'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 1.4
      });
      gsap.fromTo(pages[index].querySelector('.亲子'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.6
      });
      break;
    case 6:
      // Page4-3.vue
      gsap.fromTo(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.tu1'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.tu2'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.8
      });
      gsap.fromTo(pages[index].querySelector('.tu3'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 1.0
      });
      gsap.fromTo(pages[index].querySelector('.归家'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.2
      });
      gsap.fromTo(pages[index].querySelector('.欢聚'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.4
      });
      gsap.fromTo(pages[index].querySelector('.晚间'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.6
      });
      break;
    case 7:
      // Page4-4.vue
      gsap.fromTo(pages[index].querySelector('.空间剧本'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.HouseType'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.xingzhuang'), {
        scaleX: 0,
        opacity: 0
      }, {
        scaleX: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.8
      });
      gsap.fromTo(pages[index].querySelector('.word2'), {
        y: 20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.0
      });
      gsap.fromTo(pages[index].querySelector('.word4'), {
        y: -20,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 1.2
      });
      gsap.fromTo(pages[index].querySelector('.shijingtu'), {
        scale: 0.8,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 1.4
      });
      break;
    case 8:
      // Page5-1.vue
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.图'), {
        scale: 0.9,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.4
      });
      var elements = ['.竖线1', '.椭圆黑', '.烹饪', '.竖线2', '.椭圆黑2', '.厨房', '.深u', '.竖线3', '.椭圆黑3', '.折线白', '.椭圆白', '.大冰箱', '.竖线4', '.椭圆黑4', '.整体定制橱柜', '.竖线5', '.椭圆黑5', '.地砖', '.折线黑', '.移门'];
      elements.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 9:
      // Page5-1-1.vue
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        y: -40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.wenzi2'), {
        y: 40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.8
      });
      var groupNames = ['.one', '.two', '.three', '.four', '.five'];
      groupNames.forEach((group, i) => {
        const container = pages[index].querySelector(group);
        if (container) {
          gsap.fromTo(container, {
            scale: 0.8,
            opacity: 0
          }, {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 1.0 + i * 0.2
          });
        }
      });
      break;
    case 10:
      // Page5-1-2.vue
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        y: -40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.wenzi2'), {
        y: 40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.8
      });
      var groupNames = ['.one', '.two', '.three', '.four']; // Only 4 groups in Page5-1-2.vue

      groupNames.forEach((group, i) => {
        const container = pages[index].querySelector(group);
        if (container) {
          gsap.fromTo(container, {
            scale: 0.8,
            opacity: 0
          }, {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 1.0 + i * 0.2
          });
        }
      });
      break;
    case 11:
      // Page5-2.vue
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        y: 30,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.图'), {
        scale: 0.9,
        opacity: 0
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        delay: 0.4
      });

      // Animate elements based on actual Vue component structure
      var elements = ['.竖线1', '.椭圆黑1', '.全屋', '.中央空调', '.竖线2', '.椭圆黑2', '.竖线3', '.椭圆黑3', '.预留', '.竖线4', '.椭圆黑4', '.地暖', '.竖线5', '.椭圆黑5', '.地砖'];
      elements.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 12:
      // Page5-3.vue
      // 进入动画
      var elementsIn = ['.竖线1', '.椭圆黑1', '.阳台面宽', '.竖线2', '.椭圆黑2', '.预留洗衣机', '.大尺寸地砖', '.椭圆黑5', '.竖线5', '.预留洗手池', '.椭圆黑6', '.竖线6'];
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // 让 "图" 紧随其后出现
      gsap.fromTo(pages[index].querySelector('.图'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });

      // 按顺序依次显示其他元素
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 13:
      // Page5-4.vue
      // 进入动画
      var elementsIn = ['.竖线1', '.椭圆黑1', '.阳台mini', '.竖线2', '.椭圆黑2', '.尊享', '.椭圆黑3', '.zhexian', '.双边床头', '.椭圆黑5', '.竖线5', '.预留灵活空间', '.椭圆黑6', '.竖线6', '.预留男女'];
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // 让 "图" 紧随其后出现
      gsap.fromTo(pages[index].querySelector('.图'), {
        visibility: 'hidden'
      },
      // 初始状态，元素不可见
      {
        visibility: 'visible',
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });

      // 按顺序依次显示其他元素
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 14:
      // Page5-5.vue
      // 进入动画 - updated based on actual Vue component structure
      var elementsIn = ['.zhexian', '.椭圆黑1', '.沐光', '.竖线2', '.椭圆黑2', '.阳台推拉门', '.成长', '.椭圆黑6', '.竖线6'];
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // 让 "图" 紧随其后出现
      gsap.fromTo(pages[index].querySelector('.图'), {
        visibility: 'hidden'
      },
      // 初始状态，元素不可见
      {
        visibility: 'visible',
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });

      // 依次显示其他元素
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 15:
      // Page5-6.vue
      // Define elements to animate based on actual Vue component structure
      var elementsIn = ['.竖线2', '.椭圆黑2', '.灵感', '.椭圆黑5', '.竖线5', '.灵动'];

      // Animating "场景展示" (Scene Display)
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });

      // Animating "返回首页" (Home Button)
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // Animating the "图" element
      gsap.fromTo(pages[index].querySelector('.图'), {
        visibility: 'hidden'
      },
      // Initial state, element invisible
      {
        visibility: 'visible',
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });

      // Animate text elements like "wenzi1"
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });

      // Animate other elements sequentially
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 16:
      // Page5-7.vue
      // Define elements to animate based on actual Vue component structure
      var elementsIn = ['.竖线1', '.椭圆黑1', '.沐浴区', '.竖线11', '.椭圆黑11', '.窄边', '.zuozhexian', '.镜柜壁龛', '.椭圆黑2', '.轻智能壁挂式马桶', '.竖线12', '.椭圆黑12', '.无影美妆灯', '.地漏', '.椭圆黑3', '.youzhexian', '.椭圆黑5', '.竖线5', '.淋浴区整面踏板', '.椭圆黑51', '.youzhexian2', '.马桶上方收纳', '.椭圆黑6', '.竖线6', '.尊享星级卫浴'];

      // Animating "场景展示" (Scene Display)
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });

      // Animating "返回首页" (Home Button)
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // Animating the "图" element
      gsap.fromTo(pages[index].querySelector('.图'), {
        visibility: 'hidden'
      },
      // Initial state, element invisible
      {
        visibility: 'visible',
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });

      // Animate text elements like "wenzi1"
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });

      // Animate other elements sequentially
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 17:
      // Page5-8.vue
      // Define elements to animate based on actual Vue component structure
      var elementsIn = ['.竖线11', '.椭圆黑11', '.窄边', '.竖线112', '.椭圆黑112', '.沐浴', '.椭圆黑5', '.竖线5', '.品牌', '.椭圆黑6', '.竖线6', '.台下'];

      // Animating "场景展示" (Scene Display)
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });

      // Animating "返回首页" (Home Button)
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // Animating the "图" element
      gsap.fromTo(pages[index].querySelector('.图'), {
        visibility: 'hidden'
      },
      // Initial state, element invisible
      {
        visibility: 'visible',
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });

      // Animate text elements like "wenzi1"
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });

      // Animate other elements sequentially
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    case 18:
      // Page5-1-3.vue
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        y: -40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.wenzi2'), {
        y: 40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.8
      });
      var groupNames = ['.one', '.two', '.three', '.four', '.five'];
      groupNames.forEach((group, i) => {
        const container = pages[index].querySelector(group);
        if (container) {
          gsap.fromTo(container, {
            scale: 0.8,
            opacity: 0
          }, {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 1.0 + i * 0.2
          });
        }
      });
      break;
    case 19:
      // Page5-1-4.vue
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.2
      });
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 60,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.4
      });
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        y: -40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.6
      });
      gsap.fromTo(pages[index].querySelector('.wenzi2'), {
        y: 40,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.8
      });
      var groupNames = ['.one', '.two', '.three', '.four', '.five'];
      groupNames.forEach((group, i) => {
        const container = pages[index].querySelector(group);
        if (container) {
          gsap.fromTo(container, {
            scale: 0.8,
            opacity: 0
          }, {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 1.0 + i * 0.2
          });
        }
      });
      break;
    case 20:
      // Page5-9.vue
      // Define elements to animate based on actual Vue component structure
      var elementsIn = ['.竖线2', '.椭圆黑2', '.预留', '.超低', '.椭圆黑5', '.竖线5', '.收纳', '.椭圆黑6', '.竖线6'];

      // Animating "场景展示" (Scene Display)
      gsap.fromTo(pages[index].querySelector('.场景展示'), {
        x: -50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.1
      });

      // Animating "返回首页" (Home Button)
      gsap.fromTo(pages[index].querySelector('.gohomeImage'), {
        x: 50,
        opacity: 0
      }, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.2
      });

      // Animating the "图" element
      gsap.fromTo(pages[index].querySelector('.图'), {
        visibility: 'hidden'
      },
      // Initial state, element invisible
      {
        visibility: 'visible',
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.3
      });

      // Animate text elements like "wenzi1"
      gsap.fromTo(pages[index].querySelector('.wenzi1'), {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.inOut",
        delay: 0.4
      });

      // Animate other elements sequentially
      elementsIn.forEach((selector, i) => {
        gsap.fromTo(pages[index].querySelector(selector), {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5 + i * 0.1
        });
      });
      break;
    default:
  }
}